import { render } from "./PersonalSettingsView.vue?vue&type=template&id=a9448358&scoped=true"
import script from "./PersonalSettingsView.vue?vue&type=script&lang=js"
export * from "./PersonalSettingsView.vue?vue&type=script&lang=js"

import "./PersonalSettingsView.vue?vue&type=style&index=0&id=a9448358&scoped=true&lang=css"

import exportComponent from "/home/treim/code/trit/reclo/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9448358"]])

export default __exports__